import React from 'react';
import Dialog from '@teetsh/app/src/components/Dialog';
import { Body } from './Body';
import { useTranslation } from 'react-i18next';
import { useOpenExportLSUXmlTutoModal } from 'components/ExportLSUXmlTuto/atoms';

interface Props {
  livretEvalId: string;
  isOpen: boolean;
  onClose: () => void;
  livretEleveId?: string;
}

export function DownloadLSUModal(props: Props) {
  const { livretEvalId, isOpen, onClose, livretEleveId } = props;
  const { t } = useTranslation(['carnet']);

  const openExportLSUXmlTutoModal = useOpenExportLSUXmlTutoModal();
  return (
    <Dialog
      title={t('carnet:livret.selectLivretToFetch')}
      isOpen={isOpen}
      onClose={onClose}
      closeButton
    >
      <Body
        livretEleveId={livretEleveId}
        livretEvalId={livretEvalId}
        onSuccess={() => {
          onClose();
          openExportLSUXmlTutoModal();
        }}
        onClose={onClose}
      />
    </Dialog>
  );
}
